import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * PoolDetail 컴포넌트
 * 
 * 이 컴포넌트는 단순 리디렉션 역할을 합니다.
 * /pool/:code, /pool/:poolId 경로로 접근 시 /pool-management/:poolCode로 리디렉션합니다.
 * UI 개선 계획에 따라 PoolManagement.tsx로 모든 기능을 통합하기 위한 중간 단계입니다.
 */
const PoolDetail: React.FC = () => {
  // URL 파라미터 가져오기 (code 또는 poolId)
  const { code, poolId } = useParams<{ code?: string; poolId?: string }>();
  const navigate = useNavigate();
  
  // 실제 사용할 풀 코드 결정 (code 또는 poolId 파라미터 사용)
  const poolCode = code || poolId || '';

  // 컴포넌트 마운트시 리디렉션
  useEffect(() => {
    if (poolCode) {
      // 짧은 지연 후 리디렉션 (UX를 위한 최소한의 지연)
      const redirectTimeout = setTimeout(() => {
        navigate(`/pool-management/${poolCode}`, { replace: true });
      }, 100);
      
      return () => clearTimeout(redirectTimeout);
    } else {
      // 풀 코드가 없는 경우 풀 목록으로 이동
      navigate('/pools', { replace: true });
    }
  }, [poolCode, navigate]);

  // 리디렉션 중 로딩 표시
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <CircularProgress size={60} sx={{ mb: 2 }} />
      <Typography variant="h6">리디렉션 중...</Typography>
      <Typography variant="body2" color="text.secondary">
        시설 관리 페이지로 이동
      </Typography>
    </Box>
  );
};

export default PoolDetail; 